<template>
<div>
  <bk-input :label="$t('USERNAME.PLACEHOLDER')"
            icon="person"
            @input="change"
            :helper-text="$t(state)"
            :value="username"
            :valid="valid"
            :pristine="pristine || loading"
            :disabled="disabled"
            :watch-value="true"
            :id="id"
            :loading="loading"
            :max-length="15"
            :allow-hotjar-recording="allowHotjarRecording"
  />
  <div class="bk-username__suggestions" v-if="suggestions.length">
    <p class="bk-username__suggestions__item"
       v-for="suggestion in suggestions"
       @click="clickSuggestion(suggestion)"
    >{{suggestion}}</p>
  </div>
</div>
</template>
<script>
import debounce from 'lodash.debounce'
import { UsernameState } from '../../../mixins/usernameCheck'
import BkInput from '../../../common/BkInput'
import {debounceTime} from '../config'

export default {
  components: { BkInput },
  data () {
    return {
      /**
       * Indicator if the field is unchanged
       */
      pristine: true,
    }
  },
  props: {
    /**
     * Allow recording in HotJar by setting the appropriate classes to the input field
     */
    allowHotjarRecording: {
      type: Boolean,
      default: false
    },
    /**
     * The value of the textField
     */
    username: {
      type: String,
      required: true,
    },
    /**
     * The state of the field
     */
    state: {
      type: String,
      defaut: UsernameState.valid,
      validator (value) {
        return Object.values(UsernameState).indexOf(value) !== -1
      },
    },
    id: {
      type: String,
      required: true,
    },
    /**
     * Contains a selection of possible usernames
     */
    suggestions: {
      type: Array,
      defaut: []
    },
    /**
     * If is true the input is valid
     */
    valid: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * set the pristine to false
     * and fires the change event
     * @param payload
     */
    change (payload) {
      this.pristine = false
      this.$emit('change', payload)
    },
    clickSuggestion(payload) {
      this.change(payload)
      this.$emit('clickSuggestion')
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "../../../scss/colors";

  .bk-username__suggestions {
    display: flex;
    margin: 16px 0;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    flex-wrap: wrap;
    cursor: pointer;

    &__item {
      color: $primary;
      margin-bottom: 8px;
      text-transform: none;
    }
  }
</style>
